import { API } from "../backend";
import { isAuthenticated } from "../Auth/helper";
import Axios from "axios";

export const createNewUser = async (data) => {
  let getuserdata = isAuthenticated();
  return await fetch(`${API}admin/adduser/${getuserdata.user._id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getuserdata.token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const fetchAllUser = async (id, token) => {
  let getuserdata = isAuthenticated();
  return await fetch(`${API}admin/getAllUsers/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const deleteonlyone = async (id, token, deleteid) => {
  return await fetch(`${API}admin/deleteOneUser/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(deleteid),
  })
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const updatePassword = async (id, token, updateid) => {
  return await fetch(`${API}admin/updateUserPassword/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(updateid),
  })
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const uploadmediafile = async (id, token, productid, formdat) => {
  return await fetch(
    `${API}admin/uploadfile/${id}/${productid}`,

    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },

      body: formdat,
    }
  )
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const deletemediafile = async (id, token, productid) => {
  return await fetch(
    `${API}admin/deletefile/${id}/${productid}`,

    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getallfiles = async (id, token) => {
  return await fetch(
    `${API}admin/getAllFiles/${id}/`,

    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      console.log(response);
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getAllImagesAdmin = (id, token) => {
  return fetch(`${API}admin/images/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

export const getAllSongsAdmin = (id, token) => {
  return fetch(`${API}admin/songs/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

export const getAllSpeechAdmin = (id, token) => {
  return fetch(`${API}admin/speech/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

export const getImageDataAdmin = (id, token, musicId) => {
  return fetch(`${API}admin/images/${id}/${musicId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

export const getAllDocumentsAdmin = (id, token) => {
  return fetch(`${API}admin/documents/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

export const getAllVediosAdmin = (id, token) => {
  return fetch(`${API}admin/vedios/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((allcat) => {
      //console.log(allcat)
      return allcat.json();
    })
    .catch((e) => {
      return e;
    });
};

// Calendar Date Management API functions

export const createCalendarDate = async (data) => {
  let getuserdata = isAuthenticated();
  return await fetch(`${API}calendar/admin/create/${getuserdata.user._id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getuserdata.token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getAllCalendarDates = async () => {
  let getuserdata = isAuthenticated();
  return await fetch(`${API}calendar/admin/all/${getuserdata.user._id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getuserdata.token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const updateCalendarDate = async (calendarDateId, data) => {
  let getuserdata = isAuthenticated();
  return await fetch(
    `${API}calendar/admin/update/${getuserdata.user._id}/${calendarDateId}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getuserdata.token}`,
      },
      body: JSON.stringify(data),
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const deleteCalendarDate = async (calendarDateId) => {
  let getuserdata = isAuthenticated();
  return await fetch(
    `${API}calendar/admin/delete/${getuserdata.user._id}/${calendarDateId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getuserdata.token}`,
      },
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

// Public API functions for calendar dates (for frontend calendar display)
export const getPublicCalendarDates = async (year, month) => {
  let queryParams = "";
  if (year && month) {
    queryParams = `?year=${year}&month=${month}`;
  } else if (year) {
    queryParams = `?year=${year}`;
  }

  return await fetch(`${API}calendar/all${queryParams}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getCurrentMonthDates = async () => {
  return await fetch(`${API}calendar/current-month`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.log(e);
    });
};
